import React, {useCallback, useContext, useState} from "react";
import {AppFunctionsContext} from "../App";
import {useMutation, useQueryClient} from "react-query";
import {sendContractLink} from "../functions/api";
import {toastMessages} from "../hooks/useToastMessages";
import {InnerCellWrapper} from "../Components/ReactTable";
import _ from "lodash";
import {Button} from "../Components/Button";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import * as far from "@fortawesome/pro-regular-svg-icons";
import * as fas from "@fortawesome/pro-solid-svg-icons";

const sendEmailOverlay = 'send-email-overlay'
export const EmailModal = ({contract, client}) => {
    const {addToOverlaySet, removeFromOverlaySet, closeModal} = useContext(AppFunctionsContext);
    const queryClient = useQueryClient();
    const sendContractLinkQuery = useMutation({mutationFn: sendContractLink, mutationKey: "sendContractLink"});
    const [message, setMessage] = useState(`Hi ${client.contactName},

Following our conversation, you can review your contract for the upcoming Newcomers Guide ad using the link below:

<a href="https://portal.newcomersguide.co.il/contracts/${contract.guid}">View your contract</a>

Please take a moment to review the details, confirm everything is correct, and proceed with payment. Once payment is completed, you'll be able to upload your ad. Kindly note that all ads must be submitted by June 18th.

This link is secure and unique to you—please keep it private, as it allows access to your contract.

As a valued advertiser, you're also eligible for complimentary exposure on our website. Our online searchable directory is clear, user-friendly, and beautifully designed — putting your business at the fingertips of customers across Israel and around the world,

Click the link below to fill in your business details and customize your online listing.

<a href="https://newcomersguide.co.il/submit-your-business/">https://newcomersguide.co.il/submit-your-business/</a>

If you have any questions or need assistance, feel free to contact us at ads@newcomersguide.co.il or call 1-599-500-605.

Best regards,
${(contract.agent ? `${contract.agent}\n` : "")}The Newcomers Guide`)

    const handleSendEmail = useCallback(async () => {
        try {
            addToOverlaySet(sendEmailOverlay);
            const ret = await sendContractLinkQuery.mutateAsync({contractId: contract.id, message});

            const {
                messageArray,
            } = ret || {};

            toastMessages(messageArray, () => queryClient.invalidateQueries(["getAdminMasterLists"]));
        } finally {
            removeFromOverlaySet(sendEmailOverlay);
        }
    }, [contract.id, message])

    return (
        <div style={{height: '80vh', width: '80vw', display: "flex", flexDirection: "column", alignItems: "center"}}>
            <div style={{
                flexGrow: 1,
                width: "100%",
                margin: 6,
                display: "flex",
                alignItems: "center",
                justifyContent: "center"
            }}>
                <textarea value={message} onChange={e => setMessage(e.target.value)}
                          style={{width: "95%", height: "95%", border: "1px black solid"}}/>
            </div>
            <div style={{display: "flex", flexDirection: "row", margin: 10}}>
                <Button style={{flexGrow: 1, margin: 6}} onClick={handleSendEmail}>Send</Button><Button
                style={{flexGrow: 1, margin: 6}} onClick={closeModal}>Cancel</Button>
            </div>
        </div>
    );
};
export const EmailCell = cell => {
    const {openModal} = useContext(AppFunctionsContext);
    const {row: {original: contract = {}} = {}, clientLookup} = cell;
    const client = clientLookup[contract.clientId];
    const openEmailModal = useCallback(() => {
        openModal({
            header: 'Message Editor',
            content: <EmailModal contract={contract} client={client}/>,
        });
    }, [contract, client]);


    return <InnerCellWrapper>{_.isNil(client?.contactEmail) ?
        <span>No Email</span> :
        <>
            <Button
                onClick={openEmailModal}
            >
                {contract.lastSentLink ?
                    <>
                        <FontAwesomeIcon icon={far.faPaperPlane}/>{" "}
                        Resend Link
                    </> :
                    <>
                        <FontAwesomeIcon icon={fas.faPaperPlane}/>{" "}
                        Send Link
                    </>
                }
            </Button>
        </>}
    </InnerCellWrapper>;

}
